// Game settings and constants
export const SETTINGS = {
  CANVAS_WIDTH: 720,
  CANVAS_HEIGHT: 960,
  TARGET_FPS: 60,
  
  // Player settings
  PLAYER_SPEED: 7,
  PLAYER_HP: 3,
  PLAYER_LIVES: 3,
  PLAYER_INVULN_TIME: 1.5,
  PLAYER_FIRE_RATE: 3, // bullets per second
  PLAYER_SIZE: 72, // Increased from 48
  
  // Game mechanics
  COMBO_MULTIPLIERS: [1, 1.5, 2, 3, 5],
  COMBO_TIMEOUT: 2, // seconds without hit to reset
  
  // Difficulty scaling
  DIFFICULTY_PER_REGION: 0.15,
  
  // Power-up settings
  POWERUP_DURATION: 10, // seconds
  POWERUP_DROP_CHANCE: 0.15,
  
  // Chain system
  CITIZENS_PER_WAVE: 5,
  CITIZENS_BONUS_MULTIPLIER: 1.2,
};

export const COLORS = {
  PRIMARY: '#00ffff',
  SECONDARY: '#ff00ff',
  ACCENT: '#ffff00',
  DANGER: '#ff0000',
  SUCCESS: '#00ff00',
  TEXT: '#ffffff',
  BACKGROUND: '#0a0a0f',
};

export const REGIONS = [
  {
    id: 1,
    name: 'East Coast',
    background: 'east_coast',
    waves: 6,
    description: 'The journey begins on the Eastern shores...',
  },
  {
    id: 2,
    name: 'Midwest',
    background: 'midwest',
    waves: 6,
    description: 'Through the heartland of America...',
  },
  {
    id: 3,
    name: 'Southwest',
    background: 'southwest',
    waves: 6,
    description: 'Across the desert heat...',
  },
  {
    id: 4,
    name: 'West Coast',
    background: 'west_coast',
    waves: 6,
    description: 'To the Pacific sunset...',
  },
  {
    id: 5,
    name: 'Washington D.C.',
    background: 'dc',
    waves: 6,
    description: 'The final stand at the Capitol!',
  },
];
